import ApiBase from 'app/services/api/entities/Base'

function* checkEmailAvailability({ email }, requestOptions = {}) {
  return yield ApiBase.privatePost('/v1/users/mailbox_available/', {
    ...requestOptions,
    data: {
      mailbox: email,
    },
  })
}

function* updateMailbox({ email }, requestOptions = {}) {
  return yield ApiBase.privatePatch('/v1/users/rename_mailbox/', {
    ...requestOptions,
    data: {
      mailbox: email,
    },
  })
}

export default {
  checkEmailAvailability,
  updateMailbox,
}
